import { formatVolume } from "../../../js/utils";

const transformQuantities = (interior, newJob, quantities) => {
  const formattedQuantities = Object.fromEntries(
    Object.entries(quantities).map(([k, v]) => [k, formatVolume(v)])
  );

  const result = interior
    ? {
        ceiling_paint: formattedQuantities.ceilingPaint,
        enamel_paint: formattedQuantities.enamelPaint,
        wall_paint: formattedQuantities.wallPaint,
      }
    : {
        eco_safe_exterior_paint: formattedQuantities.wallPaint,
      };

  const primerKey = interior ? "primer" : "speciality_undercoat";

  return newJob
    ? { ...result, [primerKey]: formattedQuantities.primer }
    : result;
};

export default (form) => {
  const { csrf, email, interior, newJob, quantities } = form;

  return {
    ...csrf,
    email,
    interior,
    new_job: newJob,
    ...transformQuantities(interior, newJob, quantities),
  };
};
